module.exports = __webpack_public_path__ + "img/ics_f_kg_circle.437e2a3a.svg";